import { Component, Input } from '@angular/core';
import { UntypedFormArray } from '@angular/forms';
import { map } from 'rxjs/operators';
import { IPartnerResourceContext, Page, PartnerResourceService } from 'src/app/xena-api';

@Component({
    selector: 'app-resource-mapping',
    templateUrl: './resource-mapping.component.html',
    standalone: false
})
export class ResourceMappingComponent {
  @Input() resourceMappings: UntypedFormArray;

  constructor(private partnerResourceService: PartnerResourceService) { }

  resourcesDatasource = (queryString: string): Promise<IPartnerResourceContext[]> =>
    this.partnerResourceService.getForScheduling({ queryString, forceNoPaging: false })
      .pipe(map((x: Page<IPartnerResourceContext>) => x.entities))
      .toPromise();
}
